import { Job } from '~/shared';

import box from '~/assets/icons/box_3.svg';
import bus from '~/assets/icons/bus.svg';
import mailBox from '~/assets/icons/mail_box.svg';
import pizzaBox from '~/assets/icons/pizza_box.svg';
import powerFix from '~/assets/icons/power_fix.svg';
import taxi from '~/assets/icons/taxi_2.svg';
import logoElectrician from '../../assets/images/logo_electrician.svg';
import logoFarm from '../../assets/images/logo_farm.svg';
import logoPizza from '../../assets/images/logo_pizza.svg';
import logoPost from '../../assets/images/logo_post.svg';
import logoTaxi from '../../assets/images/logo_taxi.svg';
import previewTaxi from '../../assets/images/preview_taxi.jpg';
export type DetailedJobDescription = {
	text: string;
	images: string | [string, string] | [string, string, string];
};

export interface IJobDefinition {
	logo: string; // Логотип работы
	title: string; // Название работы возле логотипа. Пример: Работа\nтаксистом
	icon: string; // Иконка работы

	headerImage: string; // Картинка на фоне в верхней части главного меню (превью работы/ее локации)

	wordForms: [string, string, string]; // Склонения слов. Пример: заказ,заказа,заказов

	descriptionSummary: string; // Описание работы на главном меню
	descriptionDetailed: DetailedJobDescription[]; // Детальное описание работы в меню "О работе" (превью + процесс, описание механик и т.п.)
	levelsDetailed: string[]; // Описание уровней работы
}

export const JobDefinitions: Record<Job, IJobDefinition> = {
	// @TODO
	[Job.Farmer]: {
		logo: logoFarm,
		title: 'Чудная ферма\nСан-Андреас',
		icon: taxi,

		headerImage: previewTaxi,

		wordForms: ['росток', 'ростка', 'ростков'],

		descriptionSummary: `
			Добро пожаловать на ферму!
			Всё предельно просто. Вы собираете с полей урожай и относите его на склад. Чем больше вы принесёте, тем больше заработаете.
			А теперь за работу!
		`,
		descriptionDetailed: [
			{
				text: `Для сбора быстро нажимайте клавишу "E"`,
				images: '',
			},
			{
				text: `За каждую собранную единицу урожая вы будете получать определенную сумму денег`,
				images: '',
			},
			{
				text: `Склад отображается в виде красной метки на карте`,
				images: '',
			},
		],
		levelsDetailed: [
			'Вам доступны ростки на посеве',
			'Вам доступны ростки крапивы',
		],
	},
	[Job.Taxi]: {
		logo: logoTaxi,
		title: 'Работа\nтаксистом',
		icon: taxi,

		headerImage: previewTaxi,

		wordForms: ['заказ', 'заказа', 'заказов'],

		descriptionSummary: `
			Получайте заказы и подвозите пассажиров до указанных точек
		`,
		descriptionDetailed: [
			{
				text: `Ожидайте клиента`,
				images: '',
			},
			{
				text: `Подберите клиента`,
				images: '',
			},
			{
				text: `Довезите клиента до точки назначения`,
				images: '',
			},
		],
		levelsDetailed: [
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
			'Вам доступен тариф “Комфорт”, транспорт для аренды комфорт класса, а именно: Toyota Corolla, Audi A3 и BMW M3 E90',
		],
	},
	[Job.Courier]: {
		logo: logoTaxi,
		title: 'Работа\nкурьером',
		icon: box,

		headerImage: previewTaxi,

		wordForms: ['доставка', 'доставки', 'доставок'],

		descriptionSummary: `
			Загружайте товары и доставляйте до указанных точек
		`,
		descriptionDetailed: [
			{
				text: `Сядьте в личный транспорт`,
				images: '',
			},
			{
				text: `Загрузите товар на складе`,
				images: '',
			},
			{
				text: `Развезите товар по указанным точкам`,
				images: '',
			},
		],
		levelsDetailed: [
			'Вам доступна сумка-холодильник',
			'Вам доступна доставка кальяна',
		],
	},
	[Job.Bus]: {
		logo: logoTaxi,
		title: 'Работа\nавтобусником',
		icon: bus,

		headerImage: previewTaxi,

		wordForms: ['остановка', 'остановки', 'остановок'],

		descriptionSummary: `
			Доставляйте пассажиров по остановкам
		`,
		descriptionDetailed: [
			{
				text: `Сядьте в рабочий транспорт`,
				images: '',
			},
			{
				text: `Отправьтесь к началу маршрута`,
				images: '',
			},
			{
				text: `Подбирайте и доставляйте пассажиров по остановкам`,
				images: '',
			},
		],
		levelsDetailed: [
			'Вам доступен пазик',
			'Вам доступен микроавтобус',
			'Вам доступен двухэтажный автобус',
		],
	},
	[Job.PizzaDelivery]: {
		logo: logoPizza,
		title: 'Чудная ферма\nСан-Андреас',
		icon: pizzaBox,

		headerImage: previewTaxi,

		wordForms: ['доставка', 'доставки', 'доставок'],

		descriptionSummary: `
			Доставляйте пиццы по указанным адресам
		`,

		descriptionDetailed: [
			{
				text: 'Сядьте в рабочий транспорт',
				images: '',
			},
			{
				text: `Загрузите коробки с пиццей`,
				images: '',
			},
			{
				text: `Развезите пиццу по адресам`,
				images: '',
			},
		],
		levelsDetailed: [],
	},
	[Job.Electrician]: {
		logo: logoElectrician,
		title: 'Electro Co.\nШтата Сан-Андреас',
		icon: powerFix,

		headerImage: previewTaxi,

		wordForms: ['починка', 'починки', 'починок'],

		descriptionSummary: `
			Чините и еще раз чините
		`,

		descriptionDetailed: [
			{
				text: 'Сядьте в рабочий транспорт',
				images: '',
			},
			{
				text: 'Ожидайте вызова',
				images: '',
			},
			{
				text: 'Отправляйтесь на аварийный участок и почините там всё!',
				images: '',
			},
		],
		levelsDetailed: [],
	},
	[Job.Post]: {
		logo: logoPost,
		title: 'GO Postal\nПочтовое отделение',
		icon: mailBox,

		headerImage: previewTaxi,

		wordForms: ['письмо', 'письма', 'письма'],

		descriptionSummary: `
			Доставляйте письма по указанным адресам
		`,

		descriptionDetailed: [
			{
				text: 'Загрузите письмо в рабочий транспорт',
				images: '',
			},
			{
				text: 'Развозите письмо по указанным адресам',
				images: '',
			},
			{
				text: 'Получите заработок за доставленное письмо',
				images: '',
			},
		],
		levelsDetailed: [],
	},
};
